import { createRouter, createWebHashHistory } from 'vue-router'
import CheckInPage from '@/components/CheckInPage.vue'
import WeixinCallback from '@/components/WeixinCallback.vue'

const routes = [
  {
    path: '/',
    name: 'CheckIn',
    component: CheckInPage
  },
  {
    path: '/weixin/callback',
    name: 'WeixinCallback',
    component: WeixinCallback
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
